import { useSelector, useDispatch } from 'react-redux'
import { useMemo } from 'react'
import { setUser, initialState } from 'store/auth/userSlice'
import { apiLogIn, apiLogOut } from 'services/AuthService'
import { onSignInSuccess, onSignOutSuccess } from 'store/auth/sessionSlice'
import { useNavigate } from 'react-router-dom'
import { Success } from 'utils/alerts'

function useAuth() {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { token,  signedIn } = useSelector(state => state.auth.session)
    const userInfo = useSelector(state => state.auth.user)
    const { permissionList } = useSelector(state => state.listData)

    const signIn = async values => {
        try {
            const resp = await apiLogIn(values)
            if (resp.data) {
                const { access, refresh } = resp.data.token
                if (resp.data?.role?.includes('Customer') && resp.data?.role?.length === 1 && !resp.data.super_user) {
                    return {
                        status: 'failed',
                        message: 'You are not authorized',
                    }
                }
                const tokenExpiry = Date.now() + (resp.data.token.expires_in || 1800) * 1000
                dispatch(onSignInSuccess({ access, refresh, tokenExpiry }))
                if (resp.data) {
                    dispatch(
                        setUser({
                            avatar: '',
                            first_name: resp.data.first_name ?? 'User',
                            last_name: resp.data.last_name ?? '',
                            email: '',
                            super_user: resp.data.super_user,
                            user_id: resp.data.user_id,
                            role: resp.data.role,
                            permissions: resp.data.permissions ?? [],
                            branch: resp?.data?.branches?.map(item => item.id),
                            branches: resp?.data?.branches?.map(item => {
                                item.label = item.name
                                item.value = item.id
                                return item
                            }),
                        })
                    )
                }
                return {
                    status: 'success',
                    message: '',
                }
            }
        } catch (errors) {
            
            return {
                status: 'failed',
                message: errors.response?.data?.error || 'Login failed. Please try again.',
            }
        }
    }

    const handleSignOut = () => {
        dispatch(onSignOutSuccess())
        dispatch(setUser(initialState))
        navigate('/login')
    }

    const signOut = async () => {
        try {
            await apiLogOut()
            Success('Logout successfully!')
            handleSignOut()
        } catch (error) {
            // handled by BaseService interceptor
        }
    }

    const allPermissions = useMemo(
        () => Object.keys(permissionList).map(key => permissionList[key]).flat(Infinity),
        [permissionList]
    )

    const checkPermission = (module, action) => {
        if (userInfo.super_user || module === 'dashboard') return true
        let permissionsData = userInfo?.permissions ? [...userInfo?.permissions] : []
        let status = false
        permissionsData = permissionsData.map(item => allPermissions.find(({ id }) => id === item.id))
        permissionsData.map(item => {
            if (action) {
                if (module === item?.module && action === item?.action) {
                    status = true
                }
            } else {
                if (module === item?.module) {
                    status = true
                }
            }
            return item
        })

        return status
    }

    return {
        authenticated: token && signedIn,
        signIn,
        signOut,
        checkPermission,
    }
}

export default useAuth
